module.exports = __webpack_public_path__ + "static/media/wheel.18faea9d.svg";